<template>
  <div class="card mt-5 d-flex justify-content-center container ">
      <checkout v-if="status === false "/>
      <payment v-else/>
  </div>
</template>
<script setup>
import checkout from "@/agent/components/checkout/checkoutComponent.vue"
import payment from "@/agent/components/checkout/paymenMtethod.vue"
import {computed} from "vue";
import {useStore} from 'vuex'
const store = useStore()
const status = computed(() => {
  return store.state.status
})
</script>